import React, { useContext, useState } from 'react'
import { LoadingContext, M_Table, NavigateContext, BufferService } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

export default function Customers({ roles }) {

    const [refresh, setRefresh] = useState(false)
    const bufferServiceCustomer = new BufferService('Customer')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createCustomer', t("CreateCustomer"))
            return
        }

        let tempData = data
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null' || tempData.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        ctx.passValue.set('lines', data)
        if (operation === 'edit') {
            ctx2.newTab('createCustomer', t("EditCustomer"))
            return
        }
    }

    const deleteCustomerLine = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            tempData.forEach(obj => {
                deleteFunc(obj.Id)
            })
            return
        }
        deleteFunc(tempData.Id)
    }

    function deleteFunc(id) {
        bufferServiceCustomer.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessQuoteDeleted"))
            setRefresh(true)
        })
    }

    const removeContextItems = ['View', 'Copy']

    return (
        <div className='backgroundForms'>
            <div>
                <M_Table
                    roleName={'Customer'}
                    filtersOnTable
                    entityName={'Customer'}
                    removeContextItems={removeContextItems}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    includeExportExcel
                    includeTemplateExcel
                    includeImportExcel
                    rolePermissions={roles}
                    replaceFunctions={new Map([
                        ['Delete', (data) => deleteCustomerLine(data)],
                        ['Create', (data) => NewRoute('', '', 'create', data)],
                        ['Edit', (data) => NewRoute('', '', 'edit', data)]
                    ])}
                />
            </div>
            <div className='dividerTables'></div>
        </div>
    )
}